import { gql, TypedDocumentNode } from 'apollo-angular';

import {
  ISignBuyListInput,
  ISignBuyListResult,
  IAllBuyListFromOrganizationInput,
  IAllBuyListFromOrganizationResult,
  ISharePropertyWithBuyListsInput,
  ISharePropertyWithBuyListsResult,
  IIsBuyListCreationAllowedResult,
} from '@shared/models/buyers-list';

export const SIGN_BUY_LIST: TypedDocumentNode<
  ISignBuyListResult,
  ISignBuyListInput
> = gql`
  query signBuyList($dataType: BuyListSignDataType!) {
    signBuyList(dataType: $dataType) {
      fields
      key
      uploader
      url
    }
  }
`;

export const ALL_BUY_LIST_FROM_ORGANIZATION: TypedDocumentNode<
  IAllBuyListFromOrganizationResult,
  IAllBuyListFromOrganizationInput
> = gql`
  query allBuyListFromOrganization(
    $after: String
    $before: String
    $first: Int
    $last: Int
    $sort: [BuyListSortInput]
  ) {
    allBuyListFromOrganization(
      after: $after
      before: $before
      first: $first
      last: $last
      sort: $sort
    ) {
      count
      results {
        id
        name
        allowShare
      }
      # startKeyset
      # endKeyset
    }
  }
`;

export const SHARE_PROPERTY_WITH_BUY_LISTS: TypedDocumentNode<
  ISharePropertyWithBuyListsResult,
  ISharePropertyWithBuyListsInput
> = gql`
  query sharePropertyWithBuyLists($buyLists: [ID!]!, $propertyId: ID!) {
    sharePropertyWithBuyLists(buyLists: $buyLists, propertyId: $propertyId)
  }
`;

export const IS_BUY_LIST_CREATION_ALLOWED: TypedDocumentNode<IIsBuyListCreationAllowedResult> = gql`
  query isBuyListCreationAllowed {
    isBuyListCreationAllowed
  }
`;
